// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Thanks/Thanks.sass
// module id = 205
// module chunks = 0